import {
    FETCH_PROFILEUSER_BEGIN,
    FETCH_PROFILEUSER_SUCCESS,
    FETCH_PROFILEUSER_FAILURE
} from '../constants/profile';

const initialState = {
    userDetails: {},
    isLoading: false,
    error: ""
}


export const getUserDetailsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_PROFILEUSER_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_PROFILEUSER_FAILURE:
            return {
                ...initialState,
                isLoading: false,
                userDetails: null
            };
        case FETCH_PROFILEUSER_SUCCESS:
            return {
                ...initialState,
                userDetails: payload.userDetails,
                isLoading: true,
            };
        default:
            return state;
    }
}

export default getUserDetailsReducer
